import { useEffect, useRef, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import styleGrid from "./DataGrid.module.css";
import { CustomSnackbar } from "@/utils/alert";
import "./style.css";
import { SelectButton } from "../SelectButton";
import { SplitButton } from "../SplitButton";
import { leadApi } from "@/services/api/leads";
import { etapaJornadaOptions, Lead } from "../context/leadContext";
import clientApi from "@/services/api/client"; // Certifique-se de que o caminho está correto
import attendanceApi from "@/services/api/attendance";
import briefingApi from "@/services/api/briefing";
import UserService from "@/services/UserService";
import { useNavigate } from "react-router-dom";
import { CircularProgress, Alert } from "@mui/material";
import attendantApi from "@/services/api/attendant";
import GoogleAdsIcon from "@/assets/iconsTable/google-ads-svgrepo-com.svg";
import LinkMeta from "@/assets/iconsTable/link1.svg";
import Meta from "@/assets/iconsTable/Meta.svg";
import { useLeads } from "../context/leadContext";
import { formatInDate } from "@/utils/formatDate";
import { ModalDelete } from "../../../components/ModalDelete";
import { DetalhesModal } from "../DetalhesModal";

interface SelectButtonRef {
  clearSelection: () => void;
}
interface Attendant {
  id: string;
  nome: string;
} 

type Severity = "success" | "error";

export function DataGridLeands() {
  const { leads, loading, error, setLoading, setError, setLeads, leadsMemory, setLeadsMemory } = useLeads();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [attendantOption, setAttendantOption] = useState<Attendant[]>([]);
  const [selectedLeadId, setSelectedLeadId] = useState<number | null>(null);
  const [showAlert, setShowAlert] = useState(false);
  const selectButtonRef = useRef<SelectButtonRef>(null);
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedLead, setSelectedLead] = useState<Lead | null>(null);
  const navigate = useNavigate();
  const [alertInfo, setAlertInfo] = useState({
    severity: "success" as Severity,
    message: "",
  });

  useEffect(() => {}, [leads]);

  async function updateAttendant(id: number, dataAttendant: any) {
    const data = { attendantId: dataAttendant };

    try{
      await leadApi.updateLead(id, data);
        const selectedAttendant = attendantOption.find(
          (attendant) => attendant.id === dataAttendant
        );
  
        const updatedLead = {
          attendantId: dataAttendant,
          attendantName: selectedAttendant ? selectedAttendant.nome : undefined,
        };

        setLeads((prevLeads) =>
          prevLeads.map((lead) =>
            lead.id === id ? { ...lead, ...updatedLead } : lead
          )
        );
  
        setAlertInfo({
          severity: "success",
          message: "Atendente atualizado com sucesso",
        });
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 1500);
    }catch(error){
      setAlertInfo({
        severity: "error",
        message: "Erro ao atualizar atendente. Verifique os dados e tente novamente.",
      });
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 1500);
    }
  }

  async function updateEtapa(id: number, stage: string) {
    const data = { stage };

  try {
    const response = await leadApi.updateLead(id, data);
    // Atualize apenas os dados relevantes
    setLeads((prevLeads) =>
      prevLeads.map((lead) =>
        lead.id === id ? { ...lead, stage: response.data.stage || stage } : lead
      )
    );

    setAlertInfo({
      severity: "success",
      message: "Etapa atualizada com sucesso",
    });
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 1500);
  } catch (err) {
    console.error("Erro ao atualizar a etapa:", err);
    setAlertInfo({
      severity: "error",
      message: "Erro ao atualizar a etapa. Verifique os dados e tente novamente.",
    });
    setShowAlert(true);
  }
  }

  async function handleOpenModalDetails(id: number | string) {
    if (selectButtonRef.current) {
      selectButtonRef.current.clearSelection(); // Chama a função para limpar a seleção
    }
    try{
      const resposta = await leadApi.buscarLeadPorId(id);
      setSelectedLead(resposta.data);
      const atendente = await attendantApi.getAttendant(resposta.data.atendenteId);
      const loadComAtendente = {
        ...resposta.data,
        Atendente: {
          nome: atendente.data.nome
        },
      }
      setSelectedLead(loadComAtendente);

      setOpenDetails(true);
    }catch(error){
      console.log("Erro ao abrir modal de detalhes:", error);
    }
  }

  console.log('Lead:', selectedLead)

  function handleCloseModalDetails() {
    setOpenDetails(false);
    setSelectedLead(null); // Limpar selectedLead ao fechar
  }

  function handleAlertClose() {
    setShowAlert(false);
  }

  function handleOpenModalConfirm(id: number) {
    setSelectedLeadId(id);
    setOpenConfirm(true);
  }

  function handleCloseModal() {
    setOpenConfirm(false);
    if (selectButtonRef.current) {
      selectButtonRef.current.clearSelection(); // Chama a função para limpar a seleção
    }
  }

  useEffect(() => {
    if (!openConfirm) {
      setSelectedLeadId(null);
    }
  }, [openConfirm]);

  const handleCreate = (id: number) => {
    console.log(`Create action for ID: ${id}`);
  };

  async function handleCreateAtendimento(lead: any) {
    let clientId;
  
    try {
      if (!lead.telefone) {
        console.error(`Lead com ID ${lead.id} não possui um número de telefone`);
        return;
      }
  
      // 1. Verificar se o cliente já existe pelo telefone
      const findResponse = await clientApi.findByPhone(lead.telefone);
      if (findResponse.status === 200 && findResponse.data) {
        // Cliente existe, pegar o ID
        clientId = findResponse.data.id;
      }
  
      // 2. Atualizar o estágio do lead para "QUALIFICADO" se o cliente foi encontrado
      if (clientId) {
        await updateEtapa(lead.id, "QUALIFICADO");
  
        // 3. Criar atendimento com o ID do cliente existente
        await createAttendance(clientId);
  
        return; // Saímos da função após criar o atendimento com sucesso
      }
    } catch (err) {
      console.error("Erro ao criar atendimento");
   
        try {
          console.log("Cliente não encontrado, criando novo cliente e atendimento...");
          // Criar um novo cliente, já que não foi encontrado
          console.log(lead)
          const newClientData = {
            dataClient: {
              nome: lead.nome,
              telefone: lead.telefone,
              email: null,
              cpf: null,
              origem: lead.origem,
            },
            dataAddress: null,
            dataDeliveryAddress: null,
          };
  
          const createResponse = await clientApi.create(newClientData);
          if (createResponse.status !== 201 && createResponse.status !== 200) {
            throw new Error("Erro ao criar o cliente");
          }

          console.log("Cliente criado:", createResponse);
  
          clientId = createResponse.data.response.cliente.id;
  
          // Atualizar o estágio do lead para "QUALIFICADO"
          await updateEtapa(lead.id, "QUALIFICADO");
  
          // Criar atendimento com o ID do cliente recém-criado
          await createAttendance(clientId);
  
        } catch (creationError) {
          console.error("Erro ao criar o cliente ou atendimento:", creationError);
          setAlertInfo({
            severity: "error",
            message: "Erro ao criar o cliente e atendimento.",
          });
          setShowAlert(true);
        }
    }
  }

  const createAttendance = async (clientId: number) => {
    try {
      const userId = UserService.getUser()?.userId;
      if (!userId) throw new Error("Não há informação de userId");

      const attendantResponse = await attendantApi.getAttendantByUserId(userId);
      if (attendantResponse.status === 500)
        throw new Error("Erro ao recuperar atendente");

      const attendant = attendantResponse.data;
      if (!attendant)
        throw new Error(
          "Erro ao recuperar dados do atendente, atendente provavelmente não existe com este id"
        );
      const attendanceResponse = await attendanceApi.createAttendance(
        clientId,
        attendant.id
      );
      if (attendanceResponse.status === 500)
        throw new Error("Erro ao criar atendimento");

      const attendanceId = attendanceResponse.data.id;

      const briefingResponse = await briefingApi.createBriefing(attendanceId);
      if (briefingResponse.status === 500 || !briefingResponse.data)
        throw new Error("Erro ao criar briefing");

      setAlertInfo({
        severity: "success",
        message:
          "Atendimento criado com sucesso! Redirecionando para atendimentos...",
      });
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
        navigate(`/homepage?cliente=${clientId}`);
      }, 2000);
    } catch (error) {
      console.error("Erro ao criar atendimento e briefing:", error);
    }
  };

  async function handleDelete() {
    if (selectedLeadId !== null) {
      const response = await leadApi.deleteLead(selectedLeadId);
      if (response.status === 200) {
        setLeads((prevLeads) =>
          prevLeads.filter((lead) => lead.id !== selectedLeadId)
        );
        setAlertInfo({
          severity: "success",
          message: "Usuário deletado com sucesso",
        });
        setShowAlert(true);
        setOpenConfirm(false);
      }
    }
  }

  const knownOrigins: {
    [key: string]: { id: string; name: string; src: string };
  } = {
    googleads: { id: "googleads", name: "Google Ads", src: GoogleAdsIcon },
    link: { id: "link", name: "Link", src: LinkMeta },
    faceads: { id: "faceads", name: "Meta", src: Meta },
  };

  const columns: GridColDef[] = [
    { field: "nome", headerName: "Nome", minWidth: 150, flex: 2 },
    { field: "telefone", headerName: "Telefone", minWidth: 150, flex: 1.5 },
    {
      field: "origem",
      headerName: "Origem",
      minWidth: 150,
      flex: 1.5,
      renderCell: (params) => {
        const value = params.value
          ? (params.value as string).toLowerCase()
          : "";
        return (
          <div className={styleGrid.divIcon}>
            {knownOrigins[value] ? (
              <img
                src={knownOrigins[value].src}
                className="img-icon"
                alt={knownOrigins[value].name}
                style={{ width: "24px", height: "24px" }}
              />
            ) : (
              <span>{value}</span>
            )}
          </div>
        );
      },
    },
    {
      field: "stage",
      headerName: "Etapa da Jornada",
      minWidth: 220,
      flex: 2,
      renderCell: (params) => (
        <SplitButton
          value={params.row["stage"]}
          options={etapaJornadaOptions}
          onChange={async (newValue) => {
            if (params.row.stage !== newValue) {
              await updateEtapa(params.row.id, newValue);
            }
          }}
        />
      ),
    },
    {
      field: "attendantName",
      headerName: "Atendente",
      minWidth: 200,
      flex: 2,
      renderCell: (params) => (
        <SplitButton
          className="attendant-cell"
          value={params.row["attendantName"]}
          options={attendantOption.map((attendant) => attendant.nome)}
          onChange={async (newValue) => {
            const selectedAttendant = attendantOption.find(
              (attendant) => attendant.nome === newValue
            );
            if (selectedAttendant && params.row.attendantName !== newValue) {
              await updateAttendant(params.row.id, selectedAttendant.id);
            }
          }}
        />
      ),
    },
    {
      field: "createdAt",
      headerName: "Criado em",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <div>{formatInDate(params.row.createdAt, true)}</div>
      ),
    },
    {
      field: "Ações",
      headerName: "Ações",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <SelectButton
          ref={selectButtonRef}
          lead={params.row} 
          id={params.row.id}
          name={params.row.nome}
          onCreate={handleCreate}
          onUpdate={() => handleOpenModalDetails(params.row.id)}
          onDelete={() => handleOpenModalConfirm(params.row.id)}
          onCreateAtendimento={(lead) => handleCreateAtendimento(lead)}
        />
      ),
    },
  ];

  useEffect(() => {
    try {
      setLoading(true);
      attendantApi.getAttendants().then((response) => {
        const attendants = response.data.map((attendant: any) => ({
          id: attendant.id,
          nome: attendant.nome,
        }));
        setAttendantOption(attendants);
      });
    } catch (error) {
      setError(error as Error);
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <div className={styleGrid.spinnerContainer}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <div className={styleGrid.errorContainer}>
        <Alert severity="error">{error.message}</Alert>
      </div>
    );
  }

  useEffect(() => {
    const updatedLeads = leads.filter((lead) =>
      leadsMemory.some(
        (memoryLead) =>
          memoryLead.id === lead.id &&
          (memoryLead.stage !== lead.stage || memoryLead.attendantId !== lead.attendantId)
      )
    );
  
    if (updatedLeads.length > 0) {
      setLeadsMemory(leads)
    }
  }, [leads])

  return (
    <div className={styleGrid.dataGridContainer}>
      <CustomSnackbar
        open={showAlert}
        severity={alertInfo.severity}
        message={alertInfo.message}
        handleClose={handleAlertClose}
      />
      <DetalhesModal
        open={openDetails}
        close={handleCloseModalDetails}
        AttendantOption={attendantOption}
        selectedLead={selectedLead}
        local="Leads"
      />
      <ModalDelete
        open={openConfirm}
        onClose={handleCloseModal} // Função para fechar o modal
        onDelete={handleDelete} // Função para deletar
      />
      <DataGrid
        rows={leads}
        columns={columns}
        getRowId={(row) => row.id}
        className={styleGrid.dataGrid}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 15 },
          },
          sorting: {
            sortModel: [{ field: "createdAt", sort: "desc" }],
          },
        }}
        pageSizeOptions={[5, 10, 15, 50, 100]}
        checkboxSelection
      />
    </div>
  );
}
